__turbopack_context__.v({
  "container": "bNLL9a_container",
  "inputNumber": "bNLL9a_inputNumber",
  "inputOperator": "bNLL9a_inputOperator",
  "inputSubmit": "bNLL9a_inputSubmit",
});
